import { Link, useLocation } from "react-router-dom"
import { SEO } from "@/components/SEO"
import { Button } from "@/components/ui/button"
import { Home, Grid3X3, BookOpen } from "lucide-react"
import { FEATURES } from "@/config/features"

export function NotFoundPage() {
  const location = useLocation()

  return (
    <>
      <SEO
        title="Page Not Found"
        description="The page you're looking for doesn't exist."
        noindex={true}
      />
      <div className="container flex flex-col items-center py-24">
        <div className="flex flex-col md:flex-row items-center gap-6 mb-6">
          <div className="text-center">
            <p className="text-8xl font-bold text-primary">404</p>
            <h1 className="text-2xl font-bold mt-2">Page not found</h1>
          </div>
          <img
            src="/assets/images/404.png"
            alt="Page not found"
            className="w-80 md:w-96 h-auto object-contain rounded-2xl"
          />
        </div>

        <p className="text-muted-foreground mb-8 max-w-md text-justify">
          The page at <code className="text-sm bg-muted px-1.5 py-0.5 rounded">{location.pathname}</code> doesn't exist or has been moved. If you followed a link here, please let us know so we can fix it.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button asChild variant="default">
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Home
            </Link>
          </Button>
{FEATURES.mining && (
            <Button asChild variant="outline">
              <Link to="/mine">
                <Grid3X3 className="mr-2 h-4 w-4" />
                Start Mining
              </Link>
            </Button>
          )}
          <Button asChild variant="outline">
            <Link to="/docs/overview">
              <BookOpen className="mr-2 h-4 w-4" />
              Docs
            </Link>
          </Button>
        </div>
      </div>
    </>
  )
}
